import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3386">
      <Navbar data-id="element-3387" />
      <main data-id="element-3388">
        <ConsularAffairs data-id="element-3389" />
      </main>
      <Footer data-id="element-3390" />
      <FeedbackPopup data-id="element-3391" />
    </div>;
}